import React from "react";
import notAccessible from "../assets/images/not-accessible.svg";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import WhoWeAreImgpowerd from "../assets/images/powerd-logo.svg";
import { useSelector } from "react-redux";

function NotAccessible() {
  const navigate = useNavigate();
  const testData = useSelector((state) => state.testReducer);

  const handleWhoWeAre = () => {
    navigate("/");
  };

  return (
    <>
      <div className="main-not-accessible">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <img
                src={notAccessible}
                alt="logo"
                className="notaccessible-img"
              />
              {testData?.name && <h3>{testData?.name}</h3>}

              <h2>Not Accessible</h2>
              {testData?.status === "Completed" ? (
                <p>
                  This test has been <strong>closed.</strong>
                </p>
              ) : testData?.date?.endsAt && testData?.status === "Published" ? (
                <p>
                  This test has <strong>Expired</strong> on{" "}
                  {testData?.date?.endsAt}
                </p>
              ) : (
                <p>This test is no longer accessible.</p>
              )}

              <Button onClick={handleWhoWeAre}>Go Back</Button>
            </div>

            <div className="col-lg-12">
              <div className="footer-logo">
                <img
                  src={WhoWeAreImgpowerd}
                  alt=""
                  className="who-wer-are-p-img not-notaccessible-mt"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NotAccessible;
